import { Box, Alert, CircularProgress, Container } from '@mui/material'
import * as React from 'react'
import { useParams, useNavigate } from 'react-router'

import GroupSessionCard from '../components/cards/GroupSessionCard'
import useBar from '../components/common/Bar'
import GroupSessionService from '../services/GroupSessionService'

export default function GroupSessionView() {
  const { id } = useParams()
  const navigate = useNavigate()
  const bar = useBar()
  const [session, setSession] = React.useState(null)
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState(null)

  React.useEffect(() => {
    const fetchSession = async () => {
      try {
        setLoading(true)
        const data = await GroupSessionService.getGroupSession(id)
        setSession(data)
      } catch (err) {
        bar.error(err.message || 'Failed to fetch session')
        navigate('/events/sessions')
      } finally {
        setLoading(false)
      }
    }

    fetchSession()
  }, [id, navigate, bar])

  const updateHook = async () => {
    const updatedSession = await GroupSessionService.getGroupSession(id)
    setSession(updatedSession)
  }
  const deleteHook = async () => {
    navigate('/events/sessions')
  }

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    )
  }

  if (error) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    )
  }

  if (!session) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="error">Session not found</Alert>
      </Box>
    )
  }

  return (
    <Container maxWidth="md">
      <GroupSessionCard session={session} updateHook={updateHook} deleteHook={deleteHook} />
    </Container>
  )
}
